module.exports = __webpack_public_path__ + "static/media/mysql.2cf2fd30.svg";